<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <h2 class="title font-weight-bold text-uppercase">Frete Exclusivo para Caminhão</h2>
      </b-col>

      <b-col cols="12" md="7" class="form-group">
        <div class="d-flex align-items-center">
          <label class="font-weight-bold">
            Ativar frete de produtos para entrega somente por caminhão?
          </label>
          <b-form-checkbox
            switch
            v-model="freightActive"
            size="lg"
            class="ml-3"
            :disabled="!whatClerkPermission"
            @change="getProductsTruck(), $emit('enableDisableTruck')"
          ></b-form-checkbox>
        </div>
      </b-col>

      <b-col 
        v-if="freightActive" 
        cols="12"
        md="5" 
      >
        <div class="d-flex justify-content-end">
          <b-button
            variant="success"
            @click="
              $refs.selectProductModal.toggleOpen({
                title: 'Selecionar Produtos Para Frete Especial',
                item: item
              })
            "
          >
            <i class="fas fa-plus mr-1"></i>
            Selecionar Produtos
          </b-button>
          <b-button
            class="ml-2"
            variant="warning"
            @click="getProductsTruck(true)"
          >
            <i class="fas fa-eye mr-1"></i>
            Ver Produtos Selecionados
          </b-button>
        </div>
      </b-col>
      <b-col v-if="freightActive" cols="2">
        <b-form>
          <b-input-group size="lg" append="m³">
            <label>Digite o volume do caminhão (m³)</label>
            <b-form-input 
              v-model="volumeTruck"
              v-mask="['#', '#.#', '#.##','##.#', '##.##', '###.##']"
            ></b-form-input>
          </b-input-group>
        </b-form>
      </b-col>
      <b-col v-if="freightActive" cols="4">
        <b-button
          class="mt-5"
          variant="success"
          @click="$emit('saveVolume', volumeTruck)"
        >
          <i class="fas fa-save mr-1"></i>
          Salvar Volume
        </b-button>
      </b-col>
    </b-row>
    
    <FreightRulesComponent
      class="mt-4" 
      v-if="freightActive"
      :whatClerkPermission="whatClerkPermission"
      :shopkeeperId="shopkeeperId"
      :rulesFreight="getRuleTruck()"
      :typeFreightTransport="TypeFreightTransport.EXCLUSIVE_TRUCK"
      :idTypeFreight="idTypeFreight"
      @getRules="$emit('getRules')"
    />

    <SelectProductModal 
      ref="selectProductModal"
      @addOrRemoveProduct="(event) => addOrRemoveProduct(event)"
      :successUpdate="successUpdate"
    />

    <ProductSelectedFreigthModal 
      ref="productSelectedFreigthModal"
      @addOrRemoveProduct="(event) => addOrRemoveProduct(event)"
      @searchProduct="(name) => getProductsTruck(false, name)"
      :successUpdate="successUpdate"
      :shopkeeperId="shopkeeperId"
      :items="productSelected"
      :pagination="pagination"
    />

  </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import makeToast from 'Mixins/makeToast';
import FreightRulesComponent from '@/components/Freight/FreightRulesComponent.vue';
import SelectProductModal from '../Product/SelectProductModal.vue';
import ProductSelectedFreigthModal from '../Product/ProductSelectedFreigthModal.vue';
import TypeFreightTransport from '@/enums/TypeFreightTransport';

export default {
  name: 'FreighTruck',
  mixins: [makeToast],
  emits: ['getRules', 'enableDisableTruck', 'saveVolume'],

  components: {
    FreightRulesComponent,
    SelectProductModal,
    ProductSelectedFreigthModal
  },
  props: {
    whatClerkPermission: {
      type: Boolean,
      required: true,
    },
    shopkeeperId: {
      type: Number,
      required: true,
    },
    freightTruck: {
      type: Array,
      required: true,
      default: []
    },
    freightActive: {
      type: Boolean,
      required: true,
      default: false
    },
    volumeTruck: {
      type: Number,
      required: true,
      default: null
    },
  },
  data() {
    return {
      TypeFreightTransport,
      loading: false,
      successUpdate: true,
      idTypeFreight: null,
      item: [],
      productSelected: [],
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
      },
    };
  },
  methods: {
    ...mapActions('shopkeeper', [
      'updateSelectedTruck',
      'getSelectedTruck',

    ]),
    addOrRemoveProduct(event) {
      const data = {
        'id': event.idProduct,
        'construpUserId': this.shopkeeperId,
        'isTruck': event.isSelected,
        'qtdPerMeter': parseInt(event.qtdPerMeter),
      };

      this.updateSelectedTruck(data)
      .then((response) => {
        if(response.data.error) {
          this.makeToast(
            "Erro",
            "Houve um erro ao selecionar o produto, tente novamente",
            "danger"
          );
          this.successUpdate = false;
          return
        }
        this.makeToast(
          "Sucesso",
          "Produto selecionado com sucesso",
          "success"
        );
        this.successUpdate = true;
      })
      .finally(() => {});
    },
    getProductsTruck(isView = false, dataSearchProduct = []) {
      if(!this.freightActive) return;

      const name = dataSearchProduct.name ? dataSearchProduct.name : "";
      const page = dataSearchProduct.page ? dataSearchProduct.page : 1;
      
      const data = {
        construpUserId: this.shopkeeperId,
        name,
        page,
      };
      
      this.getSelectedTruck(data)
      .then((response) => {
        const { perPage, total } = response.data || {};
        
        this.pagination.itemsPerPage = perPage || 15;
        this.pagination.total = total;

        if (response.data && response.data.data) {
          this.productSelected = response.data.data;
          this.item = this.productSelected.map((item) => item.productId);

          if(isView) {
            this.$refs.productSelectedFreigthModal.toggleOpen({
            title: 'Produtos selecionados para frete'
          })
          }
        }
      })
      .finally(() => {});
    },
    getRuleTruck() {
      let data = [];
      this.freightTruck.map((item) => {
        if(item.type === TypeFreightTransport.EXCLUSIVE_TRUCK) {
          this.idTypeFreight = item.id;
          data = item.freight_rules
        }
      });
      return data;
    },
  },
};
</script>
